import React, { useState } from "react";
import { Search, Download, Building2 } from "lucide-react";

const CustomerHeader = ({ merchantId, onSwitchMerchant }) => {
  const [searchInput, setSearchInput] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (searchInput.trim()) {
      onSwitchMerchant(searchInput.trim());
      setSearchInput("");
    }
  };

  return (
    <header className="bg-white border-b border-slate-200 top-0 z-30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <div className="flex items-center gap-6">
          <div>
            <h1 className="text-xl font-bold text-slate-900">Chi tiết Khách hàng</h1>
            {merchantId && (
              <div className="flex items-center gap-2 text-xs text-slate-500 mt-0.5">
                <Building2 size={12} />
                <span>
                  Merchant_id:{" "}
                  <span className="font-mono font-bold text-blue-600">{merchantId}</span>
                </span>
              </div>
            )}
          </div>
        </div>

        <div className="flex items-center gap-3">
          <form onSubmit={handleSubmit} className="hidden sm:flex items-center gap-2">
            <div className="relative group">
              <Search
                size={16}
                className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-blue-500 transition-colors"
              />
              <input
                type="text"
                placeholder="Nhập mã cửa hàng..."
                className="pl-9 pr-4 py-2 border border-slate-200 rounded-lg text-sm bg-slate-50 focus:bg-white focus:ring-2 focus:ring-blue-100 focus:border-blue-500 transition-all outline-none w-56"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
              />
            </div>
            <button
              type="submit"
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-bold shadow-sm transition-all flex items-center gap-2"
            >
              Tìm cửa hàng
            </button>
          </form>

          <div className="h-6 w-px bg-slate-200 mx-1 hidden sm:block"></div>

          <button className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-lg text-sm font-medium text-slate-600 hover:bg-slate-50 transition-colors shadow-sm">
            <Download size={16} />
            <span className="hidden sm:inline">Xuất báo cáo</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default CustomerHeader;